import { render } from "./FamilyReunion.vue?vue&type=template&id=b39cf5a8&scoped=true"
import script from "./FamilyReunion.vue?vue&type=script&lang=js"
export * from "./FamilyReunion.vue?vue&type=script&lang=js"

import "./FamilyReunion.vue?vue&type=style&index=0&id=b39cf5a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39cf5a8"]])

export default __exports__